import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TuiRoot } from '@taiga-ui/core';
import { environment } from '../environments/environment';
import { LoggerService } from './core/services/logger.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TuiRoot],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('base-auth-angular22');

  private readonly logger = inject(LoggerService);

  constructor() {
    this.logConfiguration();
  }

  /**
   * Deja visible contra qué entorno se está trabajando.
   * El `environmentId` decide el entorno que emite el token en el login, así que
   * un valor desactualizado hace que la app traiga datos de otro sistema.
   */
  private logConfiguration(): void {
    if (environment.production) {
      return;
    }

    this.logger.info(
      `${environment.appName} v${environment.appVersion}\n` +
        `  API: ${environment.identityApiUrl}\n` +
        `  X-Environment-ID: ${environment.environmentId}`,
    );
  }
}
